import GradingEdit from "@/controllers/grading/grading-edit.js";
import axios from "axios";
import store from "@/store";

export default {
  extends: GradingEdit,

  methods: {
    async getClass(yearId) {
      try {
        const response = await axios.get("class/classList/" + yearId, {
          params: {
            campus_id: store.state.user.campus_id,
            exclude_early_year: 1,
          },
        });

        if (response.data) {
          let defaultSelectOption = [
            {
              id: 0,
              text: "Select Class",
            },
          ];

          this.classArr = defaultSelectOption.concat(response.data);
        }
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.commit("logout");
          window.location.replace("login");
        }
        console.log("Class List API Error", error);
        this.isLoading = false;
      }
    },
  },
};
